// src/components/Dashboard.jsx
import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import ConfigList from "./ConfigList";
import ScenarioRuns from "./ScenarioRuns";
import ExecutionStatus from "./ExecutionStatus";
const Dashboard = ({userId, onLoadAnalysis}) => {
  const [selectedConfigId, setSelectedConfigId] = useState(null);

  const [submissions, setSubmissions] = useState({});
  const [dismissedSubmissions, setDismissedSubmissions] = useState({});

  const handleSubmitted = (configId) => {
    setSelectedConfigId(configId);
    setSubmissions(previous => ({ ...previous, [configId]: (previous[configId] || 0) + 1 }));
  };

  const handleSelectConfig = (configId) => {
    setSelectedConfigId(configId);
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
      <ConfigList
        onSelectConfig={handleSelectConfig}
        onSubmitted={handleSubmitted}
        userId={userId}
        onLoadAnalysis={onLoadAnalysis}
      />
      <ExecutionStatus key={selectedConfigId || "unselected"} configId={selectedConfigId}
        submissionVersion={submissions[selectedConfigId] || 0}
        dismissedSubmission={dismissedSubmissions[selectedConfigId] || 0}
        onDismissSubmission={version => setDismissedSubmissions(previous => ({
          ...previous, [selectedConfigId]: version,
        }))} />
      <Typography variant="h5" sx={{ mt: 4, mb: 2 }}>
        Calculation Details{" "}
        {selectedConfigId ? `for Config ID ${selectedConfigId}` : ""}
      </Typography>
      <ScenarioRuns configId={selectedConfigId} />
    </Box>
  );
};

export default Dashboard;
